module.exports = __webpack_public_path__ + "img/logo_white_eng.87ef0404.svg";